// extracted by mini-css-extract-plugin
export default {"version":"styles_version__zBJmy"};